/** @jsx jsx */
import { jsx } from '@emotion/core';
// import { Image } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import Lottie from 'react-lottie';
import loadingAnimation from '../../../../assets/animations/gray-load.json';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { Icon } from '../../../ui/Icon';
import { Picture } from '../../../ui/Picture';

import * as styles from './index.styles';

const animationOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingAnimation,
};

// TODO WHEN IT GOING TO LIVE
const baseImageConfigs = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 327,
    height: 208,
    gravity: 'auto:subject',
  },

  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 320,
    height: 320,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 456,
    height: 296,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 752,
    height: 480,
    gravity: 'auto:subject',
  },
};

export default class Slider extends SafePureComponent {
  myRef = React.createRef();

  renderImages() {
    const { slides } = this.props;

    return slides.map((slide, index) => {
      const imageSrc = {
        value: { src: slide, alt: 'slide ' + index },
      };
      const imageAlt = slide;

      return (
        <div key={index}>
          {/* <Image field={imageSrc} /> */}
          <Picture
            image={imageSrc}
            fallbackAlt={imageAlt}
            imageSizes={baseImageConfigs}
            // pictureCss={pictureCss}
            // imageCss={imageCss}
            // isClientLink
            instantLoad
            pictureClassName="swiper-lazy"
          />
          <div className="swiper-lazy-preloader">
            <Lottie
              options={animationOptions}
              isClickToPauseDisabled
              isStopped={false}
              height={80}
            />
          </div>
        </div>
      );
    });
  }

  goPrev = () => {
    const { swiper } = this.myRef.current;
    if (swiper) {
      swiper.autoplay.stop();
      swiper.slidePrev();
    }
  };

  goNext = () => {
    const { swiper } = this.myRef.current;
    if (swiper) {
      swiper.autoplay.stop();
      swiper.slideNext();
    }
  };

  onMouseLeave = () => {
    this.myRef.current.swiper && this.myRef.current.swiper.autoplay.start();
  };

  safeRender() {
    const { Delay } = this.props;
    const swiperParams = {
      loopedSlides: 50,
      initialSlide: 1,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
        loadOnTransitionStart: false,
      },
      // preloadImages: false,

      loop: true,

      keyboard: {
        enabled: true,
      },
      centeredSlides: true,
      spaceBetween: 0,
      observer: true,
      shouldSwiperUpdate: true,
      rebuildOnUpdate: true,
      // slidesPerView: 1,
      slidesPerView: 1.1,
      spaceBetween: 16,

      autoplay: {
        delay: parseInt(Delay, 10),
        stopOnLast: false,
      },
    };
    // {/* <div css={styles.homepageSlide}> */}
    return (
      <div
        css={[styles.homepageSlide]}
        onMouseLeave={this.onMouseLeave}
        aria-hidden="true"
      >
        <Swiper ref={this.myRef} {...swiperParams}>
          {this.renderImages()}
        </Swiper>

        <button className="regus-button-prev" onClick={this.goPrev}>
          <Icon name="arrow-left" />
        </button>

        <button className="regus-button-next" onClick={this.goNext}>
          <Icon name="arrow-right" />
        </button>
      </div>
    );
  }
}
